(function () {
if (window.__lbCnInit) return;
window.__lbCnInit = true;
var html = document.documentElement;
var ROOT = (function () {
var el = document.querySelector('[data-lb-cn]');
var r = (el && el.getAttribute('data-root')) || (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
return r.charAt(r.length - 1) === '/' ? r : r + '/';
})();
var origFetch = window.fetch.bind(window);
var lastExternalAdd = 0;
function root() { return document.querySelector('[data-lb-cn]'); }
function active() {
var r = root();
if (!r) return false;
if (window.Shopify && Shopify.designMode) return true;
return window.getComputedStyle(r).display !== 'none';
}
function syncActive() {
var on = active();
html.classList.toggle('lb-cn-active', on);
if (!on) html.classList.remove('lb-cn-open');
return on;
}
syncActive();
document.addEventListener('DOMContentLoaded', syncActive);
window.addEventListener('load', syncActive);
function oldSelector() {
var r = root();
return (r && r.getAttribute('data-old-selectors')) || '#mini-cart';
}
function oldEls() {
try { return document.querySelectorAll(oldSelector()); } catch (e) { return []; }
}
function cleanupOld() {
var els = oldEls();
for (var i = 0; i < els.length; i++) {
if (els[i].hasAttribute('open')) els[i].removeAttribute('open');
}
html.classList.remove('lock-all', 'lock-mobile');
}
var oldObserver = window.MutationObserver ? new MutationObserver(function (mutations) {
if (!active()) return;
for (var i = 0; i < mutations.length; i++) {
var el = mutations[i].target;
if (el.hasAttribute && el.hasAttribute('open')) {
cleanupOld();
open();
refresh(true);
return;
}
}
}) : null;
function watchOld() {
if (!oldObserver) return;
var els = oldEls();
for (var i = 0; i < els.length; i++) {
if (els[i].hasAttribute('data-lb-cn-watched')) continue;
els[i].setAttribute('data-lb-cn-watched', '');
oldObserver.observe(els[i], { attributes: true, attributeFilter: ['open'] });
}
}
watchOld();
document.addEventListener('DOMContentLoaded', watchOld);
window.addEventListener('load', watchOld);
function cfg() {
var r = root();
if (!r || !syncActive()) return null;
return {
id: r.getAttribute('data-section-id'),
open: r.getAttribute('data-open-selectors') || '',
count: r.getAttribute('data-count-selectors') || '',
openOnAdd: r.getAttribute('data-open-on-add') !== 'false'
};
}
function safeClosest(el, sel) {
if (!sel) return null;
try { return el.closest(sel); } catch (e) { return null; }
}
var closeTimer = null;
function open() {
if (!active()) return;
if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
html.classList.remove('lb-cn-closing');
html.classList.add('lb-cn-open');
var btn = root().querySelector('.lb-cn-close');
if (btn) setTimeout(function () { btn.focus({ preventScroll: true }); }, 60);
}
function close() {
if (active()) cleanupOld();
if (!html.classList.contains('lb-cn-open') || html.classList.contains('lb-cn-closing')) return;
html.classList.add('lb-cn-closing');
closeTimer = setTimeout(function () {
html.classList.remove('lb-cn-open', 'lb-cn-closing');
closeTimer = null;
}, 300);
}
function loading(on) { html.classList.toggle('lb-cn-loading', !!on); }
function setCount(n) {
var c = cfg();
if (!c || !c.count) return;
try { document.querySelectorAll(c.count).forEach(function (el) { el.textContent = n; }); } catch (e) {}
}
function showError(msg) {
var r = root();
var el = r && r.querySelector('.lb-cn-error');
if (!el) return;
el.textContent = msg;
el.hidden = false;
}
var giftBusy = false;
var giftFailed = {};
function syncGifts() {
var r = root();
if (!r || giftBusy || !active()) return Promise.resolve();
var inner = r.querySelector('.lb-cn-inner');
if (!inner) return Promise.resolve();
var autoAdd = inner.getAttribute('data-gift-auto-add') === 'true';
var autoRemove = inner.getAttribute('data-gift-auto-remove') === 'true';
var stages = [1, 2].map(function (n) {
return {
ids: inner.getAttribute('data-gift' + n + '-ids') || ',',
want: inner.getAttribute('data-gift' + n + '-want') || '',
variant: inner.getAttribute('data-gift' + n + '-variant') || ''
};
}).filter(function (st) { return st.ids.length > 1 && st.want; });
if (!stages.length) return Promise.resolve();
giftBusy = true;
return origFetch(ROOT + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
.then(function (res) { return res.json(); })
.then(function (cart) {
var items = (cart && cart.items) || [];
var updates = {};
var hasUpdate = false;
var adds = [];
stages.forEach(function (st) {
var lines = items.filter(function (it) { return st.ids.indexOf(',' + it.product_id + ',') !== -1; });
if (st.want === 'no') {
if (autoRemove) { lines.forEach(function (l) { updates[l.key] = 0; hasUpdate = true; }); }
} else if (st.want === 'yes') {
if (!lines.length) {
if (autoAdd && st.variant && !giftFailed[st.variant]) { if (Date.now() - lastExternalAdd > 3000) adds.push(st.variant); else setTimeout(syncGifts, 3200); }
} else {
lines.forEach(function (l, i) {
if (i > 0) { updates[l.key] = 0; hasUpdate = true; }
else if (l.quantity > 1) { updates[l.key] = 1; hasUpdate = true; }
});
}
}
});
if (!hasUpdate && !adds.length) return false;
var job = hasUpdate ? post('cart/update.js', { updates: updates }) : Promise.resolve();
return job.then(function () {
if (!adds.length) return true;
return post('cart/add.js', { items: adds.map(function (id) { return { id: parseInt(id, 10), quantity: 1, properties: { _free_product: 'true', _rule_id: 'SPEND_X_0', _kite_promo_name: 'FREE Klimmzugplan' } }; }) })
.catch(function (e) {
adds.forEach(function (id) { giftFailed[id] = true; });
console.warn('[lb-cn] Gratis-Produkt konnte nicht hinzugefügt werden', e);
})
.then(function () { return true; });
});
})
.then(function (changed) {
giftBusy = false;
loading(false);
if (changed) return refresh(true);
})
.catch(function (e) {
giftBusy = false;
loading(false);
console.warn('[lb-cn] Gratis-Abgleich fehlgeschlagen', e);
});
}
var refreshSeq = 0;
function refresh(quiet) {
var c = cfg();
if (!c) return Promise.resolve();
var mySeq = ++refreshSeq;
if (!quiet) loading(true);
return origFetch(window.location.pathname + '?sections=' + encodeURIComponent(c.id), { credentials: 'same-origin' })
.then(function (r) { return r.json(); })
.then(function (data) {
if (mySeq !== refreshSeq) return;
var markup = data && data[c.id];
if (!markup) return;
var doc = new DOMParser().parseFromString(markup, 'text/html');
var fresh = doc.querySelector('.lb-cn-inner');
var current = root() && root().querySelector('.lb-cn-inner');
if (fresh && current) {
current.replaceWith(fresh);
setCount(fresh.getAttribute('data-count'));
}
})
.catch(function (e) { console.warn('[lb-cn]', e); })
.then(function () {
if (mySeq !== refreshSeq) return;
loading(false);
document.dispatchEvent(new CustomEvent('lb-cn:updated'));
return syncGifts();
});
}
function post(url, body) {
loading(true);
var isForm = body instanceof FormData;
return origFetch(ROOT + url, {
method: 'POST',
credentials: 'same-origin',
headers: isForm ? { 'Accept': 'application/json' } : { 'Content-Type': 'application/json', 'Accept': 'application/json' },
body: isForm ? body : JSON.stringify(body)
}).then(function (r) {
return r.json().then(function (d) {
if (!r.ok) throw d;
return d;
});
});
}
function fail(e) {
return refresh().then(function () {
showError((e && (e.description || e.message)) || 'Etwas ist schiefgelaufen. Bitte versuche es erneut.');
});
}
function lbPreGift(cart) {
try {
var r = root();
var inner = r && r.querySelector('.lb-cn-inner');
if (!inner || !cart || !cart.items) return cart;
var autoAdd = inner.getAttribute('data-gift-auto-add') === 'true';
var autoRemove = inner.getAttribute('data-gift-auto-remove') === 'true';
var stages = [1, 2].map(function (n) {
return { ids: inner.getAttribute('data-gift' + n + '-ids') || ',', limit: parseInt(inner.getAttribute('data-gift' + n + '-limit') || '0', 10), variant: inner.getAttribute('data-gift' + n + '-variant') || '' };
}).filter(function (st) { return st.ids.length > 1 && st.limit > 0; });
if (!stages.length) return cart;
var giftSum = 0;
stages.forEach(function (st) {
st.lines = cart.items.filter(function (it) { return st.ids.indexOf(',' + it.product_id + ',') !== -1; });
st.lines.forEach(function (l) { giftSum += l.final_line_price; });
});
var base = cart.total_price - giftSum;
var updates = {}, hasUpdate = false, adds = [];
stages.forEach(function (st) {
if (base < st.limit) {
if (autoRemove) st.lines.forEach(function (l) { updates[l.key] = 0; hasUpdate = true; });
} else if (!st.lines.length && autoAdd && st.variant && !giftFailed[st.variant]) {
adds.push(st.variant);
}
});
if (!hasUpdate && !adds.length) return cart;
var job = hasUpdate ? post('cart/update.js', { updates: updates }) : Promise.resolve();
return job.then(function () {
if (adds.length) return post('cart/add.js', { items: adds.map(function (id) { return { id: parseInt(id, 10), quantity: 1, properties: { _free_product: 'true', _rule_id: 'SPEND_X_0', _kite_promo_name: 'FREE Klimmzugplan' } }; }) });
}).catch(function () {}).then(function () { return cart; });
} catch (e) { return cart; }
}
function change(key, qty) {
return post('cart/change.js', { id: key, quantity: Math.max(0, qty) }).then(lbPreGift).then(refresh).catch(fail);
}
var upsellBusy = false;
function add(variantId) {
if (upsellBusy) return Promise.resolve();
upsellBusy = true;
return post('cart/add.js', { items: [{ id: parseInt(variantId, 10), quantity: 1 }] }).then(refresh).catch(fail)
.then(function () { upsellBusy = false; });
}
function afterExternalAdd() {
var c = cfg();
if (!c) return;
refresh().then(function () { if (c.openOnAdd) open(); });
}
window.lbCartNew = { open: open, close: close, refresh: refresh, isActive: active };
window.addEventListener('load', function () { setTimeout(function () { refresh(true); }, 800); });
document.addEventListener('click', function (e) {
var c = cfg();
if (!c || !(e.target instanceof Element)) return;
var opener = safeClosest(e.target, c.open);
if (opener && !opener.closest('[data-lb-cn]')) {
e.preventDefault();
e.stopImmediatePropagation();
open();
refresh(true);
}
}, true);
document.addEventListener('click', function (e) {
if (!(e.target instanceof Element) || !e.target.closest('[data-lb-cn]')) return;
var t = e.target;
if (t.closest('[data-lb-cn-close]')) { e.preventDefault(); close(); return; }
var qty = t.closest('[data-lb-cn-qty]');
if (qty) { e.preventDefault(); change(qty.getAttribute('data-key'), parseInt(qty.getAttribute('data-qty'), 10) || 0); return; }
var del = t.closest('[data-lb-cn-remove]');
if (del) { e.preventDefault(); change(del.getAttribute('data-key'), 0); return; }
var addBtn = t.closest('[data-lb-cn-add]');
if (addBtn) { e.preventDefault(); add(addBtn.getAttribute('data-lb-cn-add')); }
});
document.addEventListener('keydown', function (e) {
if (e.key === 'Escape' && html.classList.contains('lb-cn-open')) close();
});
window.fetch = function (input) {
var url = typeof input === 'string' ? input : (input && input.url) || '';
var p = origFetch.apply(window, arguments);
if (url.indexOf('/cart/add') !== -1) {
lastExternalAdd = Date.now();
p.then(function (r) { if (r.ok) afterExternalAdd(); }).catch(function () {});
}
return p;
};
var origOpen = XMLHttpRequest.prototype.open;
XMLHttpRequest.prototype.open = function (method, url) {
if (String(url).indexOf('/cart/add') !== -1) {
lastExternalAdd = Date.now();
this.addEventListener('load', function () {
if (this.status >= 200 && this.status < 300) afterExternalAdd();
});
}
return origOpen.apply(this, arguments);
};
var formAddBusy = false;
window.addEventListener('submit', function (e) {
var form = e.target;
if (!active() || e.defaultPrevented || !(form instanceof HTMLFormElement)) return;
if (!form.matches('form[action*="/cart/add"]')) return;
e.preventDefault();
if (formAddBusy) return;
var submittedAt = Date.now();
var data = new FormData(form);
setTimeout(function () {
if (lastExternalAdd >= submittedAt - 50) return;
formAddBusy = true;
post('cart/add.js', data)
.then(afterExternalAdd)
.catch(function (err) { open(); fail(err); })
.then(function () { formAddBusy = false; });
}, 120);
});
document.addEventListener('shopify:section:select', function (e) {
if (e.target && e.target.querySelector && e.target.querySelector('[data-lb-cn]')) open();
});
document.addEventListener('shopify:section:deselect', function (e) {
if (e.target && e.target.querySelector && e.target.querySelector('[data-lb-cn]')) close();
});
document.addEventListener('shopify:block:select', function (e) {
if (e.target && e.target.closest && e.target.closest('[data-lb-cn]')) open();
});
})();